<template lang="pug">
  .component.component-backoffice-note(v-if="item")
    .card( v-if="$is('listing')")
      .inner-content
        cardN(:showBullets="true", :showAction="true", :columns="5")
          div(slot="actionBullets")
            dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'top'")
              CommonCostButtons(:item="item", @itemUpdated="$emit('itemUpdated')")
          .field-value(slot="n1") CC{{item.id}}
          .label(slot="n2") Reason
          .field-value(slot="n2") {{item.reason}}
          .label(slot="n3") Vat {{item.tax*100}}%
          .field-value(slot="n3") {{$priceWithcurrency(item.amount.toFixed(2)) }}
          .label(slot="n4") Total Amount
          .field-value(slot="n4") {{$priceWithcurrency($priceWithVat(item.amount, item.tax).toFixed(2))}}
          .label(slot="n5") Type
          .field-value(slot="n5" v-if="item.common_cost_type_id") CT{{item.common_cost_type_id}}
          .field-value(slot="n5") {{item.common_cost_type_name}}


</template>
<script type="text/babel">
  import CardN from 'components/structure/CardN'
  import Dropdown from '../structure/foundation/Dropdown'
  import TocButtons from '../structure/ui/actions/TocButtons'
  import TocTypeButtons from '../structure/ui/actions/TocTypeButtons'
  import CommonCostButtons from '../structure/ui/actions/CommonCostButtons'

  export default {
    name: 'DocumentType',
    components: {
      CommonCostButtons,
      TocTypeButtons,
      TocButtons,
      Dropdown,
      CardN,
    },
    data() {
      return {}
    },
    created() {
    },
    methods: {},
    computed: {},
    props: {
      item: Object,
      type: {
        type: String,
        default: ''
      }
    },
  }
</script>
<style lang="sass" rel="stylesheet/sass">
</style>



// WEBPACK FOOTER //
// CommonCost.vue?e34b990c